import { datadogLogs, Logger } from "@datadog/browser-logs";

import { getRuntimeEnvironment } from "./getRuntimeEnvironment";

const isProductionBuild = import.meta.env.MODE === "production";
const environment = getRuntimeEnvironment();

if (isProductionBuild) {
  datadogLogs.init({
    clientToken:
      environment === "production"
        ? "pubc296c5cdf9541efc5f360dd77e7be746"
        : "pub6175b0f8bbecb2be93245c1e885bee9a",
    site: "datadoghq.com",
    service: "login-ui",
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    version: import.meta.env.VITE_RELEASE,
  });
}

export default (isProductionBuild
  ? datadogLogs.logger
  : { ...console }) as Logger;
